import React from "react"
import { trackCustomEvent } from "gatsby-plugin-google-analytics"
import WhatsAppIcon from "@src/images/whatsapp.svg"
import FacebookIcon from "@src/images/facebook.svg"
import InstagramIcon from "@src/images/instagram.svg"
import BlockContent from "@sanity/block-content-to-react"

interface CTActionProps {
  title: any;
  actionLabel: string;
  actionUrl: any;
}

const Icons = {
  whatsapp: <WhatsAppIcon className="text-white mr-2 w-6" />,
  facebook: <FacebookIcon className="text-white mr-2 w-6" />,
  instagram: <InstagramIcon className="text-white mr-2 w-6" />,
}

const BUTTON_COLOR = {
  whatsapp: "text-white bg-green-600 hover:bg-green-500",
  facebook: "text-white bg-blue-500 hover:bg-blue-600",
  instagram: "bg-peach-500 hover:bg-peach-600",
}

const CTAction = ({
  node: {
    title,
    actionLabel = "Programa tu cita",
    actionUrl,
  }} : { node: CTActionProps }) => {

  const redirectToWhatsApp = () => {
    if (window["fbq"]) {
      fbq("trackCustom", "CallToActionFromBlogPost", { path_to_redirect: actionUrl.url })
    }
    trackCustomEvent({
      category: "CallToActionFromBlogPost",
      action: "Click",
      label: "Redirect to WhatsApp from call to action buttons",
    })
    window.open(actionUrl.url)
  }

  const buttonClasses = [
    BUTTON_COLOR[actionUrl?.slug?.current] || "bg-peach-500 hover:bg-peach-600",
    "inline-flex items-center justify-center text-xl px-5 py-1 font-semibold border border-transparent text-base leading-6 font-base rounded-md focus:outline-none transition duration-150 ease-in-out"
  ].join(" ")

  return (
    <div className="bg-white">
      <div className="max-w-screen-xl mx-auto text-center py-12 px-4 sm:px-6 lg:py-16 lg:px-8 shadow">
        <h2 className="text-3xl leading-9 tracking-tight text-gray-900 sm:text-4xl sm:leading-10">
          <BlockContent blocks={title || []} />
        </h2>

        <div className="mt-8 flex justify-center">
          <div className="inline-flex rounded-md shadow">
            <button
              className={buttonClasses}
              onClick={redirectToWhatsApp}
            >
              {Icons[actionUrl?.slug?.current]}
              {actionLabel}
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default CTAction;